const fromAnyToLowerCase = (any) => (any === null || undefined === any ? '' : String(any)).toUpperCase();

// noinspection JSUnusedGlobalSymbols
export default fromAnyToLowerCase;
